/** HTML 模板生成 → 图片渲染相关 API */
import { apiFetch } from "@/lib/api-client";

export interface TemplateGeneratePayload {
  text: string;
  width_cm?: number;
  height_cm?: number;
  history?: Array<{ role: string; content: string }>;
}

export interface TemplateGenerateResponse {
  success: boolean;
  html?: string;
  follow_up?: string;
  error?: string;
}

export async function generateHtml(p: TemplateGeneratePayload): Promise<TemplateGenerateResponse> {
  return apiFetch<TemplateGenerateResponse>("/api/template/generate-html", {
    method: "POST",
    body: JSON.stringify(p),
    timeoutMs: 90_000,
  });
}

export interface TemplateRefinePayload {
  fragment_html: string;
  instruction: string;
  context_summary?: string;
}

/** 后端 refine-html 返回 fragment_html (不是 html) */
export interface TemplateRefineResponse {
  success: boolean;
  fragment_html?: string;
  error?: string;
}

export async function refineHtml(p: TemplateRefinePayload): Promise<TemplateRefineResponse> {
  return apiFetch<TemplateRefineResponse>("/api/template/refine-html", {
    method: "POST",
    body: JSON.stringify(p),
    timeoutMs: 90_000,
  });
}

export interface TemplateRenderPayload {
  html: string;
  width_cm: number;
  height_cm: number;
  dpi?: number;
}

/** 后端 html_renderer.render_to_image 的返回结构 */
export interface TemplateRenderResponse {
  success: boolean;
  images?: Array<{ b64_json: string }>;
  /** "WxH" 像素 */
  size?: string;
  error?: string;
}

export async function renderImage(p: TemplateRenderPayload): Promise<TemplateRenderResponse> {
  // Playwright 渲染较慢, 120s 超时
  return apiFetch<TemplateRenderResponse>("/api/template/render-image", {
    method: "POST",
    body: JSON.stringify(p),
    timeoutMs: 120_000,
  });
}
